import React, { useEffect, useState } from "react";
import {
  CModal,
  CModalBody,
} from "@coreui/react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { parse } from 'date-fns';

import { useDispatch, } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import { hideAddVehiclesModal, showAddVehiclesModal } from "../redux/vehiclesModalDispatcher";
import { addVehicleRequest, addBulkVehicleRequest } from "../redux/vehiclesDispatcher";

const AddVehicle = ({
  buttonLabel = "Add Vehicle",
  editMode = false,
  vehicleData = {},
  makeList = [],
  allList = [],
}) => {


  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false); // Local State
  const [vehicleRegistrationNumber, setVehicleRegistrationNumber] = useState([]);
  const [vehicleTitle, setVehicleTitle] = useState("");
  const [vehicleMake, setVehicleMake] = useState(null);
  const [vehicleModel, setVehicleModel] = useState(null);
  const [vehicleBodyType, setVehicleBodyType] = useState("");
  const [vehicleFuleType, setVehicleFuleType] = useState("");
  const [vehicleColor, setVehicleColor] = useState(null);
  const [vehicleYear, setVehicleYear] = useState(null);
  const [vehicleTransmission, setVehicleTransmission] = useState(null);
  const [vehicleEngineSize, setVehicleEngineSize] = useState("");
  const [vehicleNumberOfDoors, setVehicleNumberOfDoors] = useState(null);
  const [vehicleNumberOfSeats, setVehicleNumberOfSeats] = useState("");
  const [vehicleCountryOfRegistration, setVehicleCountryOfRegistration] = useState("");
  const [vehicleExpiry, setVehicleExpiry] = useState("");
  const [file, setFile] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);

  const [taxStatus, setTaxStatus] = useState("");
  const [taxFee, setTaxFee] = useState("");
  const [taxDuration, setTaxDuration] = useState("");
  const [vrc, setVrc] = useState("");
  const [co2, setCo2] = useState("");
  const [co, setCo] = useState("");
  const [hc, setHc] = useState("");
  const [nox, setNox] = useState("");
  const [hcnox, setHcnox] = useState("");
  const [particulates, setParticulates] = useState("");



  const makeOptions = React.useMemo(() => {
    return makeList.map((mak) => ({
      value: mak.id,
      label: mak.name,
    }));
  }, [makeList]);


  const [modelOptions, setModelOptions] = useState([]);

  const transmissionOptions = [
    { label: "Manual", value: "Manual" },
    { label: "Automatic", value: "Automatic" },
    { label: "CVT", value: "CVT" },
    { label: "Semi-Automatic", value: "Semi-Automatic" },
  ];


  const currentYear = new Date().getFullYear();

  const yearOptions = Array.from({ length: 50 }, (_, i) => {
    const year = currentYear - i;
    return { label: String(year), value: String(year) };
  });

  const colorOptions = [
    { label: "Black", value: "Black" },
    { label: "White", value: "White" },
    { label: "Grey", value: "Grey" },
    { label: "Blue", value: "Blue" },
    { label: "Red", value: "Red" },
    { label: "Silver", value: "Silver" },
    { label: "Green", value: "Green" },
    { label: "Brown", value: "Brown" },
    { label: "Orange", value: "Orange" },
    { label: "Yellow", value: "Yellow" },
    { label: "Beige", value: "Beige" },
    { label: "Gold", value: "Gold" },
    { label: "Other", value: "Other" },
  ];

  const doorOptions = [
    { label: "0", value: "0" },
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
  ];



 // eslint-disable-next-line react-hooks/exhaustive-deps
useEffect(() => {
  if (editMode && vehicleData) {
    setVehicleRegistrationNumber(vehicleData.registration_number || "");
    setVehicleTitle(vehicleData.title || "");

    var v = makeOptions.find(opt => opt.label === vehicleData.make);
    setVehicleMake(v);

    if (v) {
      const filteredModels = allList
        .filter(model => model.parent_id === v.value)
        .map(model => ({
          value: model.id,
          label: model.name,
        }));

      setModelOptions(filteredModels);
    } else {
      setModelOptions([]);
    }

    setVehicleModel(modelOptions.find(opt => opt.label === vehicleData.model));
    setVehicleBodyType(vehicleData.body_type || "");
    setVehicleFuleType(vehicleData.fuel_type || "");
    setVehicleColor(colorOptions.find(opt => opt.label === vehicleData.colour));
    setVehicleYear(yearOptions.find(opt => opt.label === vehicleData.year));
    setVehicleTransmission(transmissionOptions.find(opt => opt.label === vehicleData.transmission));
    setVehicleNumberOfDoors(doorOptions.find(opt => opt.label === vehicleData.number_of_doors));
    setVehicleNumberOfSeats(vehicleData.number_of_seats || "");
    setVehicleEngineSize(vehicleData.engine_size || "");
    setVehicleCountryOfRegistration(vehicleData.current_country_of_reg || "");
    setVehicleExpiry(vehicleData.nct_expiry || "");
    setFile(null);
    setUploadFile(null);

    setTaxStatus(vehicleData.tax_status || "");
    setTaxFee(vehicleData.tax_fee || "");
    setTaxDuration(vehicleData.tax_duration || "");
    setVrc(vehicleData.vrc || "");
    setCo2(vehicleData.co2 || "");
    setCo(vehicleData.co || "");
    setHc(vehicleData.hc || "");
    setNox(vehicleData.nox || "");
    setHcnox(vehicleData.hcnox || "");
    setParticulates(vehicleData.particulates || "");
  }
}, [editMode, vehicleData]); // eslint-disable-line react-hooks/exhaustive-deps




  const resetForm = () => {
    setVehicleRegistrationNumber("");
    setVehicleTitle("");
    setVehicleMake(null);
    setVehicleModel(null);
    setVehicleBodyType("");
    setVehicleFuleType("");
    setVehicleColor(null);
    setVehicleYear(null);
    setVehicleTransmission(null);
    setVehicleEngineSize("");
    setVehicleNumberOfDoors(null);
    setVehicleNumberOfSeats("");
    setVehicleCountryOfRegistration("");
    setVehicleExpiry("");
    setFile(null);
    setUploadFile(null);
    setTaxStatus("");
    setTaxFee("");
    setTaxDuration("");
    setVrc("");
    setCo2("");
    setCo("");
    setHc("");
    setNox("");
    setHcnox("");
    setParticulates("");
  };


  // Handle Add Plan Submission
  const handleAddVehicle = () => {

    var data = {


    };

    if (file === null) {

      if (vehicleRegistrationNumber.trim() === "") {
        alert("Registration number is required");
        return;
      }

      if (vehicleMake === null) {
        alert("Make is required");
        return;
      }

      if (vehicleModel === null) {
        alert("Model is required");
        return;
      }

      if (vehicleBodyType.trim() === "") {
        alert("Body type is required");
        return;
      }

      if (vehicleFuleType.trim() === "") {
        alert("Fule type is required");
        return;
      }

      if (vehicleColor === null) {
        alert("Color is required");
        return;
      }

      if (vehicleYear === null) {
        alert("Year is required");
        return;
      }

      if (vehicleTransmission === null) {
        alert("Transmission is required");
        return;
      }

      if (vehicleEngineSize.trim() === "") {
        alert("Engine size is required");
        return;
      }


      if (vehicleNumberOfDoors === null) {
        alert("Doors count is required");
        return;
      }





      if (vehicleNumberOfSeats.trim() === "") {
        alert("Seats count is required");
        return;
      }



      // if (vehicleCountryOfRegistration.trim() === "") {
      //   alert("Country of registration is required");
      //   return;
      // }

      if (vehicleExpiry.trim() === "") {
        alert("Vehicle tax expiry is required");
        return;
      }

      if (vehicleTitle.trim() === "") {
        alert("Vehicle variant is required");
        return;
      }


      data = {
        "registration_number": vehicleRegistrationNumber,
        "title": vehicleTitle || " ",
        "make": vehicleMake.label,
        "model": vehicleModel.label,
        "body_type": vehicleBodyType,
        "fuel_type": vehicleFuleType,
        "colour": vehicleColor.label,
        "year": vehicleYear.label,
        "transmission": vehicleTransmission.label,
        "engine_size": vehicleEngineSize,
        "number_of_doors": vehicleNumberOfDoors.label,
        "number_of_seats": vehicleNumberOfSeats,
        "current_country_of_reg": vehicleCountryOfRegistration,
        "nct_expiry": vehicleExpiry,
        "tax_status": taxStatus,
        "tax_fee": taxFee,
        "tax_duration": taxDuration,
        "vrc": vrc,
        "co2": co2,
        "co": co,
        "hc": hc,
        "nox": nox,
        "hcnox": hcnox,
        "particulates": particulates,
      };


      console.log("HJHJHJHJHJ", data);
      if (editMode) {
        data.id = vehicleData.id;
      }


      dispatch(addVehicleRequest(data));

    }
    else {
      data = {
        'file': uploadFile
      };

      dispatch(addBulkVehicleRequest(data));

    }









    resetForm();
    setIsModalVisible(false);
    dispatch(hideAddVehiclesModal());
  };






  const handleDateChange = (date) => {
    const formattedDate = format(date, "dd/MM/yyyy HH:mm:ss");
    setVehicleExpiry(formattedDate);
  };



  return (
    <div>
      {/* Button to Open Modal */}
      <button
        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          dispatch(showAddVehiclesModal())

        }}
        style={{
          backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: editMode === true ? "10px" : "14px",

          minWidth: "40px",
          height: editMode === true ? "24px" : "30px",  // Increased height
          padding: editMode === true ? "2px 5px" : "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>

      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          {/* Close Button */}
          <div className="cross-btn-div d-flex">
            <img
              onClick={() => setIsModalVisible(false)}
              src={crossButton}
              alt="close"
              className="cross-button"
            />
          </div>

          <form onSubmit={(e) => e.preventDefault()} className="login-form">
            <div className="mb-4">
              <h4
                className="h4 fw-bold"
                style={{ color: "#007bff", textAlign: "center" }}
              >
                <b>{editMode === true ? ("Edit Vehicle") : ("Add New Vehicle")}</b>
              </h4>
            </div>



            {/* {editMode==false?<div className="mb-3 input-login-box">
                <div className="form-row d-flex justify-content-center mt-2">
                  <input
                    type="file"
                    accept="file/*"
                    id="vehicleImageUpload"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <img
                     style={{height:"150px", width:"300px", borderRadius:"10px", objectFit:"cover"}}
                    onClick={() =>
                      document.getElementById("vehicleImageUpload").click()
                    }
                    src={file==null? placeholderImage:placeholderImage2}
                    alt="File Preview"
                    
                  />
                </div>
              </div>:<div></div>}
 */}




            {file === null ? <div>


              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={vehicleRegistrationNumber}
                    onChange={(e) => setVehicleRegistrationNumber(e.target.value)}
                    name="vehicleRegistrationNumber"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle registration"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={vehicleNumberOfSeats}
                    onChange={(e) => setVehicleNumberOfSeats(e.target.value)}
                    name="vehicleNumberOfSeats"
                    type="number"
                    className="form-control login-input"
                    placeholder="Enter vehicle no. of seats"
                    step="1"
                    min="0"
                  />



                </div>


              </div>


              <div className="d-flex gap-3 mb-3">

                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>


                  <Select
                    options={makeOptions}
                    value={vehicleMake}
                    onChange={(selectedMake) => {
                      setVehicleMake(selectedMake);
                      setVehicleModel([]);

                      const filteredModels = allList
                        .filter(model => model.parent_id === selectedMake.value)
                        .map(model => ({
                          value: model.id,
                          label: model.name,
                        }));

                      setModelOptions(filteredModels);

                      console.log("cdjkcdcdjkd:::::", allList);
                      console.log("cdjkcdcdjkd:::::", selectedMake.value);

                      console.log("cdjkcdcdjkd:::::", filteredModels);

                    }}
                    placeholder="Select make"
                  />


                  {/* <input
                  value={vehicleMake}
                  onChange={(e) => setVehicleMake(e.target.value)}
                  name="vehicleMake"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle make"
                /> */}
                </div>

                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>
                  <Select
                    options={modelOptions}
                    value={vehicleModel}
                    onChange={setVehicleModel}
                    placeholder="Select model"
                    isDisabled={!vehicleMake}
                  />

                  {/* <input
                  value={vehicleModel}
                  onChange={(e) => setVehicleModel(e.target.value)}
                  name="vehicleModel"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle model"
                /> */}


                </div>
              </div>


              <div className="d-flex gap-3 mb-3">


                <div className="mb-3 input-login-box">
                  <input
                    value={vehicleBodyType}
                    onChange={(e) => setVehicleBodyType(e.target.value)}
                    name="vehicleBodyType"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle body type"
                  />
                </div>


                <div className="mb-3 input-login-box">
                  <input
                    value={vehicleFuleType}
                    onChange={(e) => setVehicleFuleType(e.target.value)}
                    name="vehicleFuleType"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle fule type"
                  />
                </div>
              </div>


              <div className="d-flex gap-3 mb-3">



                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>


                  <Select
                    options={colorOptions}
                    value={vehicleColor}
                    onChange={setVehicleColor}
                    placeholder="Select color"
                  />


                  {/* <input
                  value={vehicleColor}
                  onChange={(e) => setVehicleColor(e.target.value)}
                  name="vehicleColor"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle color"
                /> */}
                </div>


                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>

                  <Select
                    options={yearOptions}
                    value={vehicleYear}
                    onChange={setVehicleYear}
                    placeholder="Select year"
                  />
                  {/* <input
                  value={vehicleYear}
                  onChange={(e) => setVehicleYear(e.target.value)}
                  name="vehicleYear"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle year"
                /> */}
                </div>
              </div>


              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>


                  <DatePicker
                    selected={parse(vehicleExpiry, "dd/MM/yyyy HH:mm:ss", new Date())}
                    onChange={handleDateChange}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    dateFormat="dd/MM/yyyy HH:mm:ss"
                    className="form-control login-input"
                    placeholderText="Select tax expiry date"
                  />
                  {/* <input
                  value={vehicleTransmission}
                  onChange={(e) => setVehicleTransmission(e.target.value)}
                  name="vehicleTransmission"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle transmission"
                /> */}
                </div>


                <div className="mb-3 input-login-box" style={{ flex: '1 1 0' }}>
                  <input
                    value={vehicleEngineSize}
                    onChange={(e) => setVehicleEngineSize(e.target.value)}
                    name="vehicleEngineSize"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle engine size"
                  />
                </div>

              </div>


              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box" style={{ flex: 1 }}>
                  {/* <input
                  value={vehicleNumberOfDoors}
                  onChange={(e) => setVehicleNumberOfDoors(e.target.value)}
                  name="vehicleNumberOfDoors"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter vehicle no. of doors"
                /> */}


                  <Select
                    options={doorOptions}
                    value={vehicleNumberOfDoors}
                    onChange={setVehicleNumberOfDoors}
                    placeholder="Select doors"
                  />
                </div>

                <div className="mb-3 input-login-box" style={{ flex: 1 }}>

                  <Select
                    options={transmissionOptions}
                    value={vehicleTransmission}
                    onChange={setVehicleTransmission}
                    placeholder="Select transmiss.."
                  />

                </div>

              </div>


              {/* <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={vehicleCountryOfRegistration}
                    onChange={(e) => setVehicleCountryOfRegistration(e.target.value)}
                    name="vehicleCountryOfRegistration"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle country of registration"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={vehicleNumberOfSeats}
                    onChange={(e) => setVehicleNumberOfSeats(e.target.value)}
                    name="vehicleNumberOfSeats"
                    type="number"
                    className="form-control login-input"
                    placeholder="Enter vehicle no. of seats"
                    step="1"
                    min="0"
                  />



                </div>
              </div> */}











              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={taxStatus}
                    onChange={(e) => setTaxStatus(e.target.value)}
                    name="taxStatus"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle tax status"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={taxFee}
                    onChange={(e) => setTaxFee(e.target.value)}
                    name="taxFee"
                    type="number"
                    className="form-control login-input"
                    placeholder="Enter vehicle tax fee"
                    step="1"
                    min="0"

                  />



                </div>
              </div>






              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={taxDuration}
                    onChange={(e) => setTaxDuration(e.target.value)}
                    name="taxDuration"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle tax duration"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={vrc}
                    onChange={(e) => setVrc(e.target.value)}
                    name="vrc"
                    className="form-control login-input"
                    placeholder="Enter vehicle VRC"

                  />



                </div>
              </div>


              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={co2}
                    onChange={(e) => setCo2(e.target.value)}
                    name="co2"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle Co2"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={co}
                    onChange={(e) => setCo(e.target.value)}
                    name="co"
                    className="form-control login-input"
                    placeholder="Enter vehicle Co"

                  />






                </div>
              </div>



              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={hc}
                    onChange={(e) => setHc(e.target.value)}
                    name="hc"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle hc"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={nox}
                    onChange={(e) => setNox(e.target.value)}
                    name="nox"
                    className="form-control login-input"
                    placeholder="Enter vehicle nox"

                  />






                </div>
              </div>





              <div className="d-flex gap-3 mb-3">
                <div className="mb-3 input-login-box">
                  <input
                    value={hcnox}
                    onChange={(e) => setHcnox(e.target.value)}
                    name="hcnox"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle hcnox"
                  />
                </div>

                <div className="mb-3 input-login-box" >
                  <input
                    value={particulates}
                    onChange={(e) => setParticulates(e.target.value)}
                    name="particulates"
                    className="form-control login-input"
                    placeholder="Enter vehicle particulates"

                  />






                </div>
              </div>


              <div className="d-flex gap-3 mb-3">


                <div className="mb-3 input-login-box">
                  <input
                    value={vehicleTitle}
                    onChange={(e) => setVehicleTitle(e.target.value)}
                    name="vehicleTitle"
                    type="text"
                    className="form-control login-input"
                    placeholder="Enter vehicle variant"
                  />
                </div>



              </div>





            </div> : <div></div>}

































            {/* 
  const [planType, setPlanType] = useState(""); */}

            {/* Submit Button */}
            <button
              className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
              type="button"
              onClick={handleAddVehicle}
            >
              {editMode ? "Update" : "Submit"}
            </button>
          </form>
        </CModalBody>

      </CModal>
    </div>
  );
};

export default AddVehicle;
